import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const DetailsContent = ({ data, boName, hasPermission }) => {
    const [limit, setLimit] = useState(10);
    const passedLimit = data?.length > limit;

    const navigate = navigateHook();

    const seeMoreOrLess = () => {
        setLimit(prev => prev ? null : 10);
    };

    useEffect(() => {
        let values = [];

        data.map(element => {
            values.push([
                element.type,
                element.qty,
                element.bo_ids,
            ]);
        });

        ReportUtils.createExportableTable(["Tipo de subtração", "Quantidade", `${boName}`], values, `Detalhamento por ${boName}`, "bo-stolen-detail-data");
    }, [data]);

    return (
        <>
            <table id="bo-stolen-detail-data" className="table report-table mb-6!" sheet-name={`Itens Subtraídos por ${boName}`}>

                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className="w-[25%]">Tipo</th>
                        <th className="w-[15%]">Quantidade</th>
                        <th className="w-[60%]">{boName}</th>
                    </tr>
                </thead>

                <tbody className="bg-white">
                    { (limit ? data.slice(0, limit) : data).map((element, index) => {
                        return (
                            <tr key={index}>
                                <td className="w-[25%]">{element.type}</td>
                                <td className="w-[15%]">{element.qty}</td>
                                <td className="w-[60%]">
                                    {element.bo_ids?.split(',')?.map((id) => id.trim())?.map((id, index, array) => {
                                        const ids = id.replace('/', '-').replace(' ', '');

                                        return (
                                            <React.Fragment key={`${id}-${index}`}>
                                                {hasPermission ? (<a onClick={() => navigate(`/bo/redirect/${ids}`, true)} className={'inner-link'} title={`Acessar ${boName} - ${id}`}>{id}</a>) : (<span>{id}</span>)}
                                                {index !== array.length - 1 && ', '}
                                            </React.Fragment>
                                        );
                                    })}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            { passedLimit &&
                <div className="text-end mt-1">
                    <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
                </div>
            }
        </>
    );
};

export default DetailsContent;